import React, { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import {
  AccordionBlueUpArrow,
  TrashIcon,
  TrashIconDisable,
} from '../../../../../img/findcare/FindCareSVG';
import { AvatarFacilitySVG } from '../../../../../img/SearchIndicatorSVG';
//import ShowMoreLess from 'src/Admin/components/ListWithShowMoreLess';
import ListWithShowMoreLess from 'src/Admin/components/common/ListWithShowMoreLess';
import DoctorViewListItem from './FacilityView/DoctorViewListItem';
import DoctorsPanel from './FacilityView/DoctorsPanel/DoctorsPanel';
import { maskTaxIDString } from 'src/common/masking';

const FacilitiesViewListItem = ({
  data,
  index,
  selectedDoctors,
  doctorAllData,
  setDoctorAllData,
  allowDoctorSelection,
  onSelectedDocHandler,
  onUnSelectedDocHandler,
  onTrashButtonClickHandler,
  editAffiliatedRecords,
  onDoctorTrashButtonClickHandler,
  showDoctorTrashIcon = true,
  onAddAllRecordsSameTaxId,
  selectedAllFacilitiesOfSameTaxId,
  maskTaxId = false,
}) => {
  const facility = data;
  console.log('FacilitiesViewListItem facility------', facility);

  const [showMoreDoctors, setShowMoreDoctors] = useState(false);
  const [idx, setIdx] = useState([]);
  console.log('selectedDoctors facility Review and confirm', selectedDoctors);

  const RenderDoctorListItem = ({ data }) => {
    console.log('DATA Review and Confirm +++++++', data);
    const doctor = data;
    return (
      <DoctorViewListItem
        doctor={doctor}
        onDeleteClick={(e) =>
          onDoctorTrashButtonClickHandler(e, doctor.FacilityOid, doctor)
        }
        showDoctorTrashIcon={showDoctorTrashIcon}
        maskTaxId={maskTaxId}
      />
    );
  };

  const addAllRecords = (taxId) => {
    onAddAllRecordsSameTaxId(taxId);
  };

  return (
    <div>
      <div className="blob-accordion-container-facility">
        <Accordion.Toggle
          as={Card.Header}
          className="panel-toggle text-left w-100"
          variant="link"
          eventKey={facility.FacilityOID}
          onClick={() => {
            if (idx.includes(index)) {
              setIdx(idx.filter((i) => i !== index));
            } else {
              setIdx([...idx, index]);
            }
          }}
        >
          <div className="d-flex panel-card-header">
            <div className="d-flex align-items-center ">
              <span className="arrow">
                <AccordionBlueUpArrow
                  svgClassName={!idx.includes(index) ? 'down-arrow' : ''}
                  className="acc-arrow"
                />
              </span>
              <div className="d-flex align-items-center ">
                <div className="avatar-facility d-flex pr-2">
                  <AvatarFacilitySVG />
                </div>
                <div>
                  <div>
                    <span className="blob-item-name-1">
                      {facility?.FacilityName}{' '}
                    </span>
                  </div>
                  {facility?.Address && (
                    <div className="blob-item-desc-1">
                      {facility?.Address[0]?.address1 && (
                        <span>
                          {facility?.Address[0]?.address1} &nbsp;&nbsp;
                        </span>
                      )}
                      {facility?.Address[0]?.address2 && (
                        <span>
                          {facility?.Address[0]?.address2}&nbsp;&nbsp;
                        </span>
                      )}
                      {facility?.Address[0]?.address3 && (
                        <span>
                          {facility?.Address[0]?.address3}&nbsp;&nbsp;
                        </span>
                      )}
                      {facility?.Address[0]?.city && (
                        <span>{facility.Address[0]?.city}&nbsp;&nbsp;</span>
                      )}
                      {facility?.Address[0]?.county && (
                        <span>{facility?.Address[0]?.county}&nbsp;&nbsp;</span>
                      )}
                      {facility?.Address[0]?.state_prov && (
                        <span>
                          {facility?.Address[0]?.state_prov}&nbsp;&nbsp;
                        </span>
                      )}
                      {facility?.Address[0]?.country && (
                        <span>{facility?.Address[0]?.country}&nbsp;&nbsp;</span>
                      )}
                      {facility?.Address[0]?.postalCode && (
                        <span>
                          {facility?.Address[0]?.postalCode}&nbsp;&nbsp;
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center ">
              <div>
                {allowDoctorSelection && (
                  <DoctorsPanel
                    facilityOIDProps={facility?.FacilityOID}
                    //facilityTaxIdProps={facility?.TaxId}
                    doctorAllData={doctorAllData}
                    setDoctorAllData={setDoctorAllData}
                    //selectedDoctorData={}
                    onSelectedDocHandler={onSelectedDocHandler}
                    onUnSelectedDocHandler={onUnSelectedDocHandler}
                    selectedDoctor={selectedDoctors}
                  />
                )}
                {facility.TaxId && (
                  <div className="tax-id">
                    Tax ID:{' '}
                    {maskTaxId
                      ? maskTaxIDString(facility.TaxId)
                      : facility.TaxId}
                  </div>
                )}
              </div>

              {onTrashButtonClickHandler && (
                <div>
                  {onTrashButtonClickHandler ? (
                    editAffiliatedRecords ? (
                      <button
                        type="button"
                        className="trash-button"
                        onClick={() =>
                          onTrashButtonClickHandler(
                            facility.FacilityOID,
                            selectedDoctors,
                            facility.TaxId,
                          )
                        }
                      >
                        <TrashIcon />
                      </button>
                    ) : (
                      <button type="button" className="trash-button">
                        <TrashIconDisable />
                      </button>
                    )
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={facility.FacilityOID}>
          <Card.Body>
            {selectedDoctors && (
              <ListWithShowMoreLess
                data={selectedDoctors[facility.FacilityOID] || []}
                RenderItemComponent={RenderDoctorListItem}
                showMoreLabel={'Doctors'}
                showMore={showMoreDoctors}
                setShowMore={setShowMoreDoctors}
              />
            )}
          </Card.Body>
        </Accordion.Collapse>
      </div>
      {facility.TaxId &&
        facility.TaxId !== null &&
        selectedAllFacilitiesOfSameTaxId &&
        !selectedAllFacilitiesOfSameTaxId.includes(facility.TaxId) && (
          <div className="same-tax-records">
            <button
              type="button"
              className="panel-card-link"
              onClick={() => addAllRecords(facility.TaxId)}
            >
              Add all records with the same Tax ID
            </button>
          </div>
        )}
    </div>
  );
};

export default React.memo(FacilitiesViewListItem);
